import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => {
  // Drawer styling
  const notificationsPanelMaxHeight = theme.spacing(67);
  const notificationsPanelWidth = theme.spacing(56);

  return {
    paper: {
      display: 'flex',
      flexDirection: 'column',
      width: notificationsPanelWidth,
      maxHeight: notificationsPanelMaxHeight,
      zIndex: 10001,
      position: 'fixed',
      top: theme.spacing(4),
      right: theme.spacing(2),
      background: theme.evPalette.salt['100'],
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: theme.spacing(2),
      borderBottom: `1px solid ${theme.evPalette.charcoal['500']}`,
    },
    headerText: {
      fontSize: theme.typography.pxToRem(20),
      lineHeight: theme.typography.pxToRem(24),
      color: theme.evPalette.charcoal['900'],
    },
    dayText: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(26),
      color: theme.evPalette.charcoal['700'],
    },
    notificationListBox: {
      overflowX: 'overlay',
    },
    listSubHdr: {
      color: theme.evPalette.aloe[700],
      backgroundColor: theme.evPalette.salt[100],
    },
  };
});
